import styled, { css } from 'styled-components';
import { font } from '@design/templateFns';
import { space, color, query } from '@design/templateFns';

// BUTTONS

/*** FILTER BUTTONS */
// FilterButton
export const ButtonContainer = styled.div`
  display: flex;
  overflow: visible;
  justify-content: space-between;
`;

export const FButtonWrapper = styled.div<{ $allFilters?: boolean }>`
  position: ${({ $allFilters }) => ($allFilters ? 'initial' : 'relative')};
  display: ${({ $allFilters }) => ($allFilters ? '' : 'none')};
  @media screen and (${query.atLeast('desktop')}) {
    display: flex;
  }
`;
export const FButton = styled.button<{ $selected?: boolean; $all?: boolean }>`
  color: ${color('gray4')};
  ${font('subhead-xs')}
  padding: ${space('sm')} ${space('md')};
  cursor: pointer;
  border: 1px solid ${color('gray2')};
  border-radius: 4px;
  background: ${({ $selected }) => ($selected ? color('gray1')() : 'transparent')};
  margin-right: ${space('xl')};
  display: ${({ $all }) => ($all ? 'flex' : 'none')};
  align-items: center;
  white-space: nowrap;

  &::last-child {
    margin-right: 0;
  }

  @media screen and (${query.atLeast('desktop')}) {
    display: flex;
    ${font('subhead-sm')}
  }

  &:hover,
  &:active {
    background: ${color('gray1')};
  }

  svg {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-left: 14px;
  }
`;

/*** FILTER MODALS */
// Modal General Styling

export const FModalWrapper = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 29px);
  left: -${space('xl')};
  width: 100%;
  min-width: 348px;
  min-height: 100%;
  box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
  padding: ${space('x6')} ${space('xl')} ${space('xl')};
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: ${color('bg')};
  z-index: 9;
  display: ${({ $open }) => ($open ? 'none' : '')};
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalSection = styled.div`
  margin: 0 0 ${space('x6')} 0;
`;

export const ModalHeader = styled.h5`
  color: ${color('fg')};
  ${font('body-md')}
  padding-bottom:0;
  margin-bottom: ${space('xs')};
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
`;

export const ModalButton = styled.button<{ $isDisable?: boolean }>`
  ${font('subhead-sm')}
  padding: ${space('sm')} ${space('xl')};
  cursor: pointer;
  color: ${color('bg')};
  background-color: ${color('fg')};
  border: 1px solid transparent;
  border-radius: 4px;
  ${({ $isDisable }) =>
    $isDisable &&
    `background-color: lightgrey;
     cursor: not-allowed;
`}
`;

export const ModalButtonSecond = styled(ModalButton)`
  color: ${color('fg')};
  background-color: ${color('bg')};
  border-color: ${color('fg')};
`;

export const SectionDivider = styled.hr`
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: ${color('gray2')};
  margin: 40px 0px;
`;

// Buy/Rent Tab
export const BuyRentWrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: ${space('x6')};
`;

export const BuyRentInnerWrapper = styled.div`
  background-color: ${color('gray4')};
  border-radius: 6px;
  display: inline-block;
  border: 1px solid ${color('gray2')};
`;

export const TabButton = styled.button<{ $active?: boolean; $left?: boolean }>`
  ${font('eyebrow-sm')};
  border: none;
  text-decoration: none;
  background-color: transparent;
  color: ${color('bg')};
  cursor: pointer;
  padding: ${space('sm')} calc(${space('xl')} - 2px);
  ${({ $active }) =>
    $active &&
    css`
      background-color: ${color('gray1')};
      color: ${color('gray5')};
      border-radius: 4px;
      @media screen and (${query.atLeast('desktop')}) {
        border-radius: 4px;
      }
    `}
`;

// Property Types
export const PropertyTypesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: ${space('sm')};
  grid-column-gap: ${space('md')};
`;
export const PropertyTypesTitle = styled.label`
  display: flex;
`;
export const PropertyType = styled.div<{ $isDisable?: boolean }>`
  color: ${({ $isDisable }) => ($isDisable ? color('gray2') : color('gray4'))};
  display: -webkit-box;
  align-items: flex-start;
  cursor: pointer;
  ${font('body-md-light')}
  line-height: 1.1;
  margin-bottom: 3px;
`;

export const PropertyTypesCheck = styled.input<{ $isDisable?: boolean }>`
  width: ${space('lg')};
  height: ${space('lg')};
  cursor: ${({ $isDisable }) => ($isDisable ? 'none' : 'pointer')};
  margin-right: ${space('sm')};

  appearance: none;
  background-color: ${color('bg')};
  margin: 2px ${space('sm')} 0 0;
  font: inherit;
  color: currentColor;
  border: 1px solid ${({ $isDisable }) => ($isDisable ? color('gray2') : color('gray4'))};
  border-radius: 4px;
  transform: translateY(-0.075em);
  position: relative;

  &::before {
    content: '';
    transform: scale(0) translate(-50%, -50%) rotate(45deg);
    width: 7px;
    height: 13px;
    border-right: 1px solid ${color('fg')};
    border-bottom: 1px solid ${color('fg')};
    background-color: rgba(255, 255, 255, 0.2);
    display: block;
    top: 38%;
    left: 60%;
    position: absolute;
    transform-origin: right;
  }
  &:checked {
    border: 1px solid ${color('fg')};
  }
  &:checked + div {
    color: ${color('fg')};
  }
  &:checked::before {
    transform: scale(1) translate(-50%, -50%) rotate(45deg);
  }
`;

// BEDS & BATHS
export const BBOuter = styled.div`
  margin-bottom: calc(${space('x6')} + 3px);
`;
export const BBButtonContainer = styled.div`
  display: flex;
  padding-bottom: ${space('sm')};
`;

export const BBButtonContainerMarginBtm = styled.div`
  margin-bottom: calc(${space('x6')} + 3px);
`;

export const BBButton = styled.button<{ $selected?: boolean }>`
  border-top: 1px solid ${color('gray2')};
  border-bottom: 1px solid ${color('gray2')};
  border-left: 1px solid ${color('gray2')};
  border-right: none;
  cursor: pointer;
  padding: ${space('sm')};
  color: ${color('gray4')};
  background: ${({ $selected }) => ($selected ? `${color('gray1')}` : 'transparent')};
  ${font('body-md-light')}

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
    border-right: 1px solid ${color('gray2')};
  }
  &:hover {
    background-color: ${color('gray1')};
  }
`;

/*** PRICE TAB */

// Text Fields
export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 315px;
  height: 40px;
  margin-bottom: ${space('md')};
  gap: ${space('md')};
  .MuiTextField-root p.MuiTypography-root {
    padding-bottom: 0;
  }
`;

export const BetweenDash = styled.span`
  color: ${color('fg')};
`;

/*** ALL FILTERS */
export const AllFiltersWrapper = styled.div`
  background: ${color('bg')};
  padding: 0 ${space('xl')};
  position: relative;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  flex: 1;

  @media screen and (${query.atLeast('tablet')}) {
    padding: 0 ${space('x8')};
  }
`;

export const BigHeader = styled.h4`
  ${font('headline-xxs')}
  padding: 0;
  margin: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-xs')}
  }
`;

export const SecondHeader = styled.h5`
  ${font('body-sm')}
  margin: 0 0 ${space('x6')} 0;
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md')}
  }
`;

export const ModalButtonWrapperFixed = styled(ModalButtonWrapper)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${space('lg')};
  justify-items: stretch;
  box-shadow: 0px 1px 41px rgba(0, 0, 0, 0.1);
  padding: ${space('x5')} ${space('x8')};
  position: relative;

  @media screen and (${query.below('tablet')}) {
    padding: ${space('x5')} ${space('xl')};
    grid-template-columns: 1fr;
  }
`;

export const ModalButtonFixed = styled(ModalButton)`
  padding: ${space('sm')} ${space('x5')};
  ${({ $isDisable }) =>
    $isDisable &&
    `background-color: lightgrey;
    cursor: not-allowed;
  `}

  @media screen and (${query.below('tablet')}) {
    width: 100%;
  }
`;

export const ModalButtonSecondFixed = styled(ModalButtonSecond)`
  padding: ${space('sm')} ${space('x5')};
  @media screen and (${query.below('tablet')}) {
    margin: 0;
    width: 100%;
  }
`;

export const ValidationError = styled.div`
  color: #e60100;
  ${font('body-sm')};
`;

export const TopDefault = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${space('x6')} ${space('xl')};
  @media screen and (${query.atLeast('tablet')}) {
    padding: ${space('x6')} ${space('x8')};
  }
`;
export const textFieldStyles = {
  borderColor: '#D4D4D4',
  color: '#757575',
  borderRadius: '4px',
  '& .MuiOutlinedInput': {
    color: '#242323',
  },
  // For Date Picker
  '& .MuiIconButton': {
    color: '#242323',
  },
};
